import * as React from 'react';

import {MarketingBody} from 'shells/typography/marketing-body';
import {MarketingHeader} from 'shells/typography/marketing-header';

export function ResubscribedPage() {
    return (
        <div className='flex flex-dir-col py-32'>
            <MarketingHeader>Welcome back!</MarketingHeader>
            <MarketingBody>You’ve successfully been re-subscribed.</MarketingBody>
        </div>
    );
}
